// extracted by mini-css-extract-plugin
export default {"after-action-close-icon":"ShowPhoto_after-action-close-icon_jszAR","img-tips-wrapper":"ShowPhoto_img-tips-wrapper_Rd7IQ"};